{
    "hero": {
      "title": "Rejista ya Sovereign Offset",
      "subtitle": "Jukwaa la usimamizi wa mikopo ya kaboni lililorahisishwa linaunga mkono watengenezaji wa miradi, wakaguzi, na washikaji wa mikopo pamoja na ufuatiliaji wa mizunguko kamili na uthibitisho.",
      "badges": {
        "article6": "Inafuata Kifungu cha 6",
        "unfccc": "Inalingana na UNFCCC",
        "blockchain": "Imeunganishwa na Blockchain"
      }
    },
    "access": {
      "title": "Chagua Njia Yako ya Kuingia",
      "subtitle": "Chagua jukumu lako ili kupata zana maalum za usajili na usimamizi",
      "developer": {
        "title": "Mtengenezaji wa Mradi",
        "description": "Wasilisha miradi, simamia nyaraka, na fuatilia utoaji wa mikopo",
        "register": "Jisajili",
        "login": "Ingia"
      },
      "auditor": {
        "title": "Mkaguzi (DOE)",
        "description": "Thibitisha miradi na kutoa huduma za uthibitisho",
        "register": "Jisajili",
        "login": "Ingia"
      },
      "trader": {
        "title": "Mshikaji wa Mikopo / Mchuuzi",
        "description": "Nunua, chuuza, na staafu mikopo ya kaboni",
        "register": "Jisajili (Bure)",
        "login": "Ingia"
      },
      "government": {
        "title": "Serikali / DNA",
        "description": "Usimamizi wa kiutawala na usimamizi wa kanuni",
        "register": "Jisajili",
        "login": "Ingia"
      },
      "legacy": {
        "title": "Usajili wa Mradi wa Urithi",
        "description": "Kwa miradi iliyopo inayohama kutoka viwango vingine (ICS, CDM, VCS)",
        "button": "Usajili wa Njia ya Utii"
      }
    },
    "announcements": {
      "title": "Matangazo ya Hivi Karibuni",
      "items": {
        "doe_guidelines": {
          "title": "Miongozo Mpya ya Uthibitisho wa DOE",
          "description": "Mahitaji yaliyosasishwa kwa usajili wa Shirika la Uendeshaji Lililoainishwa na uthibitisho wa uwanda wa kisekta.",
          "date": "Desemba 15, 2024"
        },
        "article6_update": {
          "title": "Sasisho la Utekelezaji wa Kifungu cha 6",
          "description": "Midia iliyoboreshwa ya mbinu za kushirikiana sasa inapatikana kwa uhamisho wa kimataifa.",
          "date": "Desemba 10, 2024"
        },
        "maintenance": {
          "title": "Arifa ya Matengenezo ya Mfumo",
          "description": "Matengenezo yaliyopangwa Desemba 20, 2024 kuanzia 2:00-4:00 AM UTC.",
          "date": "Desemba 8, 2024"
        }
      }
    },
    "downloads": {
      "title": "Upakuzi wa Nyaraka",
      "items": {
        "pin_template": "Kiolezo cha PIN",
        "pdd_template": "Kiolezo cha PDD",
        "npramp_guide": "Mwongozo wa NPRAMP",
        "user_manual": "Mwongozo wa Mtumiaji"
      }
    },
    "explorer": {
      "title": "Mchunguzi wa Rejista",
      "subtitle": "Vinjari miradi inayofanya kazi na miamala ya mikopo",
      "filters": {
        "all_categories": "Aina Zote",
        "all_status": "Hali Zote",
        "search_button": "Tafuta Rejista"
      },
      "stats": {
        "active_projects": "Miradi Inayofanya Kazi",
        "credits_issued": "Mikopo Iliyotolewa",
        "credits_retired": "Mikopo Iliyostaafu"
      }
    }
}